import $ from 'jquery';
import 'jquery.easing';

let winHeight = 0;
const resizeHandler = ()=>{

  winHeight = $(window).height();

}

const timer = (func, delay)=>{
  setTimeout(()=>{
    func();
  }, delay);
}

$(()=>{


  $(window).on('load resize', resizeHandler).on('scroll.prlx', (e)=>{

    let st = $(e.currentTarget).scrollTop();
    let count = 0;
    

    let lastThisY = 0;
    let currentSectionIndex = 1;
    let currentSectionRealIndex = 0;

    let delayCount = 0;

    if(st > 100) {
      $('.indicator').addClass('hidden');
    } else {
      $('.indicator').removeClass('hidden');
    }
    
    if(st > 400) {
      $('.scroll-top-button').addClass('visible');
    } else {
      $('.scroll-top-button').removeClass('visible');
    }

    $('.video-container').each((i, elem) => {
      let thisY = $(elem).offset().top;
      let ratio =  0.8;

      if(thisY <= st + winHeight * ratio){
        //min 30 max 90
        let containerWidth = Math.min(Math.max(((st + winHeight - thisY) / winHeight) * 100, 20), 90);
        let containerHeight = Math.min(Math.max(((st + winHeight - thisY) / winHeight) * 100, 40), 100);
        $('.video-wrapper').css({width: containerWidth + 'vw', height: containerHeight + '%'});
      } 

    });

    $('.works-section').each((i, elem) => {
      let thisY = $(elem).offset().top;
      let ratio =  0.8;

      if(thisY <= st + winHeight){
        $('.slogan-section, .sns-links, .email').css({transform: 'translateY(-' + ((st + winHeight) - thisY) * 0.5 + 'px)'});
      } else {
        $('.slogan-section, .sns-links, .email').css({transform: 'translateY(0)'});
      }

    });




  });
  
});


$(window).on('load resize', function(){
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});


$(window).on('load', function(){
  $('.slogan').addClass('executed');
  //get text of .slogan and wrap each letter with span. keep br tag
  let sloganText = $('.slogan').html();
  let sloganTextArray = sloganText.split('<br>');
  let sloganTextArray2 = [];
  for(let i = 0; i < sloganTextArray.length; i++){
    sloganTextArray2.push(sloganTextArray[i].split(''));
  }
  let sloganTextArray3 = [];
  for(let i = 0; i < sloganTextArray2.length; i++){
    sloganTextArray3.push(sloganTextArray2[i].map((elem)=>{
      return '<span>' + elem + '</span>';
    }));
  }
  let sloganTextArray4 = [];
  for(let i = 0; i < sloganTextArray3.length; i++){
    sloganTextArray4.push(sloganTextArray3[i].join(''));
  }
  let sloganTextArray5 = sloganTextArray4.join('<br>');
  $('.slogan').html(sloganTextArray5);

  $('.slogan').addClass('ready');

  //add class to each span in .slogan and add animation delay
  $('.slogan span').each((i, elem)=>{
    //add class to each elem delay random 500 ~ 1500. Use setTimeout
    let delay = Math.random() * 800 + 50;
    timer(()=>{
      $(elem).addClass('executed');
    }, delay)
    // $(elem).css({'transition-delay': delay + 's'}).addClass('executed');

  });

  timer(()=>{
    $('body').addClass('loaded');
  }, 1500)


});
